import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getReportSettingKenList } from './APIS'
import { ReportSettingKens } from '../Utils/types'

// Initial state
const initialState = {
  kens: [] as ReportSettingKens[],
  total: 0,
  loading: false,
  error: null as string | null,
}

export const getReportSettingKenListThuck = createAsyncThunk(
  'ReportSettingKenList/getReportSettingKenListThuckThuck',
  async (params: any) => {
    return await getReportSettingKenList(params)
  },
)

const ReportSettingKenListSlice = createSlice({
  name: 'ReportSettingKenList',
  initialState,
  reducers: {
    updateConnectivity(state, action) {
      console.log('state.filters', action.payload)
      const { ken, connectivity_type } = action.payload
      state.kens = state.kens.map((k) => {
        if (k.ken === ken) {
          k.connectivity_type = connectivity_type
        }
        return k
      })
    },
    clearRecord(state, action) {
      state.kens = []
      state.total = 0
      state.error = ''
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportSettingKenListThuck.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getReportSettingKenListThuck.fulfilled, (state, action) => {
        const report = action.payload as any
        state.loading = false
        state.kens = [...state.kens, ...report.items]
        state.total = report.total
      })
      .addCase(getReportSettingKenListThuck.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Unknown error'
        state.kens = []
      })
  },
})

export const { updateConnectivity, clearRecord } = ReportSettingKenListSlice.actions
export default ReportSettingKenListSlice.reducer
